import { useGetSettings, useUpdateSettings } from '@/state/agent';
import { useEffect, useState } from 'react';

export const useEnableNebulySettings = (enabled: boolean = true) => {
    const { mutateAsync: updateSettings, isLoading: updateLoading } = useUpdateSettings();
    const { data: settings, isLoading: settingsLoading } = useGetSettings(enabled);
    const [isEnabled, setIsEnabled] = useState<boolean | undefined>(undefined);

    useEffect(() => {
        if (settings?.agents_insights_is_enabled !== undefined) {
            setIsEnabled(settings?.agents_insights_is_enabled);
        }
    }, [settings]);

    const handleEnableAgentInsights = async (_: unknown, checked: boolean) => {
        setIsEnabled(checked);

        const updatedSettings = {
            agents_insights_is_enabled: checked,
        };
        await updateSettings(updatedSettings);
    };

    return {
        isLoading: updateLoading || settingsLoading,
        isEnabled,
        toggle: handleEnableAgentInsights,
    };
};
